import type { ReactNode } from "react";
import { Stack } from "@mui/material";

// Barra acima da tabela: filtros de um lado, ações do outro, quebrando linha em tela estreita.
export function CrudToolbar({ children }: { children: ReactNode }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} sx={{ mb: 2 }}>
      {children}
    </Stack>
  );
}
